var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFourSquareCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24380",
    "data-name": "Group 24380",
    transform: "translate(7164 211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001-menu",
    "data-name": "001-menu",
    transform: "translate(-7151.67 -198.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11956",
    "data-name": "Group 11956",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11955",
    "data-name": "Group 11955",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M5.425,0H1.138A1.138,1.138,0,0,0,0,1.137V5.424A1.138,1.138,0,0,0,1.138,6.56H5.425A1.138,1.138,0,0,0,6.561,5.424V1.137A1.138,1.138,0,0,0,5.425,0Z",
    transform: "translate(-0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M171.93,0h-4.287a1.138,1.138,0,0,0-1.137,1.137V5.424a1.138,1.138,0,0,0,1.137,1.137h4.287a1.138,1.138,0,0,0,1.137-1.137V1.137A1.138,1.138,0,0,0,171.93,0Z",
    transform: "translate(-158.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M5.425,166.507H1.138A1.138,1.138,0,0,0,0,167.644v4.287a1.138,1.138,0,0,0,1.137,1.137H5.425a1.138,1.138,0,0,0,1.137-1.137v-4.287A1.138,1.138,0,0,0,5.425,166.507Z",
    transform: "translate(-0.001 -158.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M171.93,166.507h-4.287a1.138,1.138,0,0,0-1.137,1.137v4.287a1.138,1.138,0,0,0,1.137,1.137h4.287a1.138,1.138,0,0,0,1.137-1.137v-4.287A1.138,1.138,0,0,0,171.93,166.507Z",
    transform: "translate(-158.107 -158.107)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourSquareCircle);
export default __webpack_public_path__ + "static/media/four-square_circle.79134cc58d1ee7cdf7e6192dd0cd51a9.svg";
export { ForwardRef as ReactComponent };